import { useRef, useState, useEffect } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import potImg1L from '../images/Parallax3A_L.webp'
import potImg2L from '../images/Parallax3B_L.webp'
import { PotContainer } from './styled'
const Pot = () => {
  const ref = useRef(null)
  const [isDesktop, setIsDesktop] = useState<boolean>(false)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })

  const moveL = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['0px', '10px', '20px']
  )
  const moveR = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['0px', '-10px', '-20px']
  )
  const rotate = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['0deg', '10deg', '20deg']
  )
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024)
    }

    handleResize() // set initial value
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  })

  return (
    <PotContainer ref={ref}>
      <motion.div
        style={{
          position: !isDesktop ? 'absolute' : 'relative',
          left: !isDesktop ? '50%' : 'auto',
          width: 'fit-content',
          transformOrigin: 'center',
          translateX: moveL,
          rotate: rotate,
        }}
      >
        <img src={potImg1L} alt="pot1" />
      </motion.div>
      <motion.div
        style={{
          position: !isDesktop ? 'absolute' : 'relative',
          left: !isDesktop ? '50%' : 'auto',
          width: 'fit-content',
          transformOrigin: 'center',
          translateX: moveR,
          rotate: rotate,
        }}
      >
        <img src={potImg2L} alt="pot2" />
      </motion.div>
    </PotContainer>
  )
}
export default Pot
